import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Layout from "../../components/Layout";
import { apiCRMv3 } from "../../services/api";
import Swal from "sweetalert2";

const EditUserSettings = ({ userId }) => {
    const location = useLocation();
    const history = useHistory();
    const cpf = location.state?.cpf;
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [settings, setSettings] = useState({});
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await apiCRMv3.get(`user-settings/settings-by-user?cpf=${cpf}`);
                if (!response.data?.data?.userSettings) {
                    Swal.fire({
                        type: "warning",
                        title: "Não encontrado",
                        text: "Usuário não encontrado no CRM para este CPF.",
                    }).then(() => history.push("/user-change-password"));
                    return;
                }
                setSettings(response.data.data.userSettings);
            } catch (error) {
                console.error("Erro ao carregar configurações:", error);
                Swal.fire({
                    type: "error",
                    title: "Erro",
                    text: "Erro ao Carregar Configurações"
                }).then(() => history.push("/user-change-password"))
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, [cpf]);

    const handleChange = (key, value) => {
        setSettings((prev) => ({ ...prev, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSaving(true);
        try {
            await apiCRMv3.put("/user-settings/update-by-user", { cpf, ...settings });
            Swal.fire({
                type: "success",
                title: "Sucesso!",
                text: `Configurações salva com sucesso!`,
            }).then(() => history.push("/user-change-password"));
        } catch (error) {
            console.error("Erro ao salvar:", error);
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Erro ao Atualizar Configurações"
            }).then(() => history.push("/user-change-password"))
        } finally {
            setSaving(false);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center p-5">
                <p>Carregando configurações...</p>
            </div>
        );
    }

    const booleanFields = {
        lostClicks: "Clientes Remarketing",
        cashbacks: "DinDinZin",
        clientLists: "Funil de Vendas 2.0",
        birthdays: "Clientes Aniversariantes",
        rightTimes: "Inativos",
        eligibleWarrantys: "Garantias Elegíveis",
        easyBuys: "Pagando Últimas Parcelas",
        buyIntentions: "Intenções de Compra",
        lifeTimes: "Lifetime",
        afterSales: "Pós-Vendas",
        debtNegotiations: "Negociação de Dívidas",
        singleCards: "Cartão Avulso",
        directMails: "Mala Direta",
        outlets: "Outlet",
        artSocialNetworks: "Arte Redes Sociais",
        managerOffers: "Ofertas do Gerente",
        gazinbooks: "Giro Gazin",
        productsPrime: "Produtos Prime",
        bestDeals: "Melhor Negócio",
        learnMore: "Aprenda Mais",
        registerBuyIntentions: "Registrar Intenções de Compra",
        productsLaunch: "Lançamento de Produtos",
        currentOffers: "Ofertas Vigentes",
        myCards: "Meu Cartão",
        generatedNarratedTabloids: "Tabloides Narrados Gerados",
        narratedTabloids: "Tabloide Narrado",
        salesFunnel: "Funil de Vendas 3.0",
        consortium: "Consórcio",
        gazinBank: "GazinBank",
        mattresses: "Colchões",
        superCombo: "Super Combo",
        visitSchedules: "Agendamentos",
        findTargetCustomers: "Encontrar Clientes Alvo",
        userPerformance: "Performance do Vendedor"
    };

    const handleCheckAll = () => {
        const updated = {};

        Object.keys(booleanFields).forEach((key) => {
            updated[key] = true;
        });

        setSettings((prev) => ({
            ...prev,
            ...updated,
        }));
    };

    const handleUncheckAll = () => {
        const updated = {};

        Object.keys(booleanFields).forEach((key) => {
            updated[key] = false;
        });

        setSettings((prev) => ({
            ...prev,
            ...updated,
        }));
    };


    return (
        <Layout pageTitle="Editar Configurações">
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    minHeight: "100vh",
                    paddingTop: "2rem",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "900px",
                        padding: "1rem",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                    }}
                >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                    }}>
                        <h4 className="m-0">
                            Editar Configurações do Usuário {cpf}
                        </h4>
                        <button
                            onClick={() => setShowModal(true)}
                            style={{
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                padding: "8px 16px",
                                cursor: "pointer",
                            }}
                        >
                            Ajuda
                        </button>
                    </div>
                    {showModal && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                            }}
                            onClick={() => setShowModal(false)} // fecha clicando fora
                        >
                            <div
                                style={{
                                    backgroundColor: "white",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    width: "90%",
                                    maxWidth: "500px",
                                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                                }}
                                onClick={(e) => e.stopPropagation()} // evita fechar ao clicar dentro
                            >
                                <h2 style={{ marginBottom: "10px" }}>Ajuda!</h2>
                                <p>
                                    Aqui você pode ativar ou desativar as funcionalidades disponíveis
                                    para este usuário. Basta usar os botões de alternância (on/off) e
                                    clicar em <strong>Salvar Alterações</strong>.
                                </p>
                                <h3>Itens Disponiveis</h3>
                                <p>
                                    -Clientes Remarketing <br></br>
                                    -DinDinZin <br></br>
                                    -Funil de Vendas 2.0 <br></br>
                                    -Funil 3.0 <br></br>
                                    -Clientes Aniversário <br></br>
                                    -Inativos <br></br>
                                    -Garantias Elegíveis <br></br>
                                    -Pagando Últimas Parcelas <br></br>
                                    -Consórcio <br></br>
                                    -Pós Venda <br></br>
                                    -Gazin Bank <br></br>
                                    -Colchões <br></br>
                                    -Intenções de Compra <br></br>
                                    -Cartão Avulso <br></br>
                                    -Mala Direta <br></br>
                                    -Oferta de Gerente <br></br>
                                    -Giro Gazin <br></br>
                                    -Ofertas Vigentes <br></br>
                                    -Meu Cartão <br></br>
                                    -Super Combo <br></br>
                                    -Agendamentos <br></br>
                                    -Encontrar Clienes Alvos <br></br>
                                    -Performance do Vendedor <br></br>
                                </p>
                                <div style={{ textAlign: "right", marginTop: "20px" }}>
                                    <button
                                        onClick={() => setShowModal(false)}
                                        style={{
                                            backgroundColor: "#6c757d",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "6px",
                                            padding: "8px 16px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Fechar
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <br></br>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {Object.entries(booleanFields).map(([key, label]) => (
                                <div
                                    className="col-12 col-md-6 col-lg-4 mb-3"
                                    key={key}
                                >
                                    <div
                                        className="form-check form-switch d-flex align-items-center"
                                        style={{ gap: "0.5rem" }}
                                    >
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={key}
                                            checked={!!settings[key]}
                                            onChange={(e) =>
                                                handleChange(key, e.target.checked)
                                            }
                                            style={{ transform: "scale(1.8)" }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor={key}
                                            style={{ marginBottom: 10, marginLeft: "0.9rem" }}
                                        >
                                            {label}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="d-flex justify-content-end mb-3" style={{ gap: "10px" }}>
                            <br></br>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleCheckAll}
                            >
                                Marcar Todos
                            </button>

                            <button
                                type="button"
                                className="btn btn-warning"
                                onClick={handleUncheckAll}
                            >
                                Desmarcar Todos
                            </button>
                        </div>
                        <div className="d-flex justify-content-center mt-4" style={{ alignItems: "center", justifyContent: "center", marginLeft: "30%" }}>
                            <br></br>
                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={saving}
                            >
                                {saving ? "Salvando..." : "Salvar Alterações"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    );
};

export default EditUserSettings;
